var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6248 4.21917C15.1935 3.87416 14.5642 3.94408 14.2192 4.37534C13.8742 4.8066 13.9441 5.4359 14.3754 5.78091L17.1493 8.00004H4.00006C3.44777 8.00004 3.00006 8.44775 3.00006 9.00004C3.00006 9.55232 3.44777 10 4.00006 10H20.0001C20.4247 10 20.8031 9.73179 20.9437 9.33104C21.0843 8.9303 20.9564 8.48447 20.6248 8.21917L15.6248 4.21917ZM8.37536 19.7808C8.80662 20.1258 9.43592 20.0559 9.78093 19.6247C10.1259 19.1934 10.056 18.5641 9.62475 18.2191L6.85084 16H20.0001C20.5523 16 21.0001 15.5522 21.0001 15C21.0001 14.4477 20.5523 14 20.0001 14H4.00006C3.57537 14 3.197 14.2682 3.05643 14.669C2.91585 15.0697 3.04374 15.5155 3.37536 15.7808L8.37536 19.7808Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChange);
export default __webpack_public_path__ + "static/media/change.79bbf12c8936f74044eceff79f57c1d6.svg";
export { ForwardRef as ReactComponent };